import { FC, useContext, useMemo } from 'react';

import {
  GenericDataFormContext,
  GroupedCoverageCardsList,
  QuotationInfoContext,
} from '../../../../../shared';
import { StepThreeFormContext } from '../../contexts/StepThreeForm';
import { StepTwoFormContext } from '../../../StepTwo/contexts/StepTwoForm/StepTwoFormContext';

import {
  groupCardsByCommonSection,
  GroupedCoveragesCardsResult,
} from '../../../../../utils';
import { ContentSection } from '../../../../../../../../../shared/components';

interface CoveragesCivilSectionProps {
  tabKey: number;
}

export const CoveragesCivilSection: FC<CoveragesCivilSectionProps> = ({
  tabKey,
}) => {
  const {
    stepThreeCivilQuotationForm,
  } = useContext(StepThreeFormContext);

  const { stepTwoForm } = useContext(StepTwoFormContext);

   const { quotationInfo } = useContext( QuotationInfoContext );

  const { allCoveragesPerPlan, getRelationWithOtherCoverage } = useContext(GenericDataFormContext);

  const planSelected = stepTwoForm?.getFieldValue(`plan-tab-${tabKey}`);

  const allCoveragesByTab = useMemo(
    () =>
      allCoveragesPerPlan.find((el) => String(el.plan as string) === String(planSelected))
        ?.coverages,
    [allCoveragesPerPlan, tabKey]
  );

  const groupedCoveragesCardsResult: GroupedCoveragesCardsResult =
    useMemo(() => {
      return allCoveragesByTab
        ? groupCardsByCommonSection(allCoveragesByTab, 'codigoFamilia')
        : {};
    }, [allCoveragesByTab]);

  return (
    <ContentSection level='h3' title='Coberturas' hasCard={false}>
      {/* Show ungrouped items first */}
      {Object.keys(groupedCoveragesCardsResult).map((key, index) => {
        if (!groupedCoveragesCardsResult[key].title) {
          return (
            <GroupedCoverageCardsList
              key={key}
              quotationInfo={quotationInfo}
              groupedCoverageKey={key}
              groupedCoveragesCardsResult={groupedCoveragesCardsResult}
              tabKeyForm={`civil-tab-${tabKey}`}
              usedFormToCoverageCard={stepThreeCivilQuotationForm}
              allCoveragesByTabList={allCoveragesByTab ?? []}
              getRelationWithOtherCoverage={getRelationWithOtherCoverage}
              className={index !== 0 ? 'mt-2' : 'grouped-coverages-first-title'}
            />
          );
        }
      })}

      {Object.keys(groupedCoveragesCardsResult).map((key, index) => {
        if (groupedCoveragesCardsResult[key].title) {
          return (
            <GroupedCoverageCardsList
              quotationInfo={quotationInfo}
              key={key}
              groupedCoverageKey={key}
              groupedCoveragesCardsResult={groupedCoveragesCardsResult}
              tabKeyForm={`civil-tab-${tabKey}`}
              usedFormToCoverageCard={stepThreeCivilQuotationForm}
              allCoveragesByTabList={allCoveragesByTab ?? []}
              getRelationWithOtherCoverage={getRelationWithOtherCoverage}
              className={index !== 0 ? 'mt-2' : 'grouped-coverages-first-title'}
            />
          );
        }
      })}
    </ContentSection>
  );
};
